module.exports = __webpack_public_path__ + "src/assets/images/index_icon9.png";